const API = process.env.REACT_APP_BACKEND_URL;

export const track = (event, properties = {}, opts = {}) => {
  try { window.opinly?.track?.(event, properties, opts); } catch (err) { console.warn('[analytics] track failed', err); }
};

export const identify = (email) => {
  if (!email) return;
  try { window.opinly?.identify?.({ email }); } catch (err) { console.warn('[analytics] identify failed', err); }
};

export const trackServer = async (event, properties = {}, opts = {}) => {
  try {
    await fetch(`${API}/api/analytics/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({ event, properties, anonId: window.opinly?.anonId || undefined, ...opts }),
    });
  } catch (err) {
    console.warn('[analytics] server event failed', err);
  }
};

export const trackLead = (source, properties = {}, email) => {
  const externalEventId = `lead-${source}-${window.opinly?.anonId || 'anon'}-${Date.now()}`;
  track('generate_lead', { source, ...properties }, { externalEventId });
  trackServer('generate_lead', { source, ...properties }, { externalEventId, email: email || undefined });
};
